export default __webpack_public_path__ + "static/media/phosphate-remover.e7e43ba0.png";